const introSection = {
  heading: "Hi all, I,m Safwan Mamji",
  description:
    "Full-time software engineer 👨‍💻 with a passion for creating mobile apps and web apps. I have more that 3 of experience, and I am committed to delivering the highest quality of work. I am adept at Flutter, React Js, Node Js, and Blockchain, and I am always looking for new ways to challenge myself and expand my skills. I am motivated by the opportunity to work with diverse teams and am eager to contribute my knowledge and enthusiasm to any project.",
  email: "safwandev957@gmail.com",
  resume:
    "https://drive.google.com/file/d/1jKhsqBi73306hga4stirBUR1JAmBNt92/view?usp=sharing",
  mypic: "safwan_small.png",
  contact: [
    {
      icon: "fb.svg",
      url: "https://www.facebook.com/safwan.khan.75286",
    },
    {
      icon: "linkedin.svg",
      url: "https://www.linkedin.com/in/safwan-idrees-0a490b115/",
    },
    {
      icon: "mail.svg",
      url: "mailto:safwandev957@gmail.com",
    },
    {
      icon: "github.svg",
      url: "https://github.com/safwanidrees/",
    },
  ],
};
const skillSection = {
  softwareSkills: [
    {
      icon: "flutter_icon.svg",
      title: "Flutter",
      experience: 2.5,
    },
    {
      icon: "dart_icon.svg",
      title: "Dart",
      experience: 2.5,
    },
    {
      icon: "firebase_icon.svg",
      title: "Firebase",
      experience: 2.5,
    },
    {
      icon: "react_icon.svg",
      title: "React Js",
      experience: 2,
    },
    {
      icon: "js_icon.svg",
      title: "Javascript",
      experience: 2,
    },

    {
      icon: "node_icon.svg",
      title: "Node Js",
      experience: 1.5,
    },

    {
      icon: "sql_icon.png",
      title: "SQL",
      experience: 1,
    },
    {
      icon: "cloud_icon.png",
      title: "Google Cloud",
      experience: 1,
    },
    {
      icon: "cloud_icon.png",
      title: "Dialogflow",
      experience: 1,
    },
  ],
  skillDetails: [
    {
      icon: "flutter_icon.svg",
      title: "MOBILE APPS DEVELOPEMENT",
      description:
        "I can develop best of the best Android and Ios app for you using Flutter framework. I am using best approaches and patterns that I have learned. I have a good experience on flutter state management using bloc, provider and getx. I always keep user experience in mind while writing code so that app is always responsive and fast.",
    },
    {
      icon: "react_icon.svg",
      title: "WEB APPS DEVELOPEMENT",
      description:
        "I can develop highly interactive Front end / User Interfaces for your Web Apps using React Js and also Flutter. I am using best approaches and patterns that I have learned. I have a good experience on react state management using redux and context Api.",
    },
    {
      icon: "firebase_icon.svg",
      title: "FIREBASE INTEGRATION",
      description:
        "I have a good experience of Firebase, I have integrated Firebase Firestore, Firebase Realtime Database, Firebase Functions, Cloud Messaging, Dynamic Links, Firebase ML etc.",
    },
  ],
  proficiency: [
    {
      title: "Flutter",
      percent: 95,
      experience: 9.5,
    },
    {
      title: "Dart",
      percent: 90,
      experience: 9,
    },
    {
      title: "Firebase",
      percent: 85,
      experience: 8.5,
    },
    {
      title: "Javascript",
      percent: 80,
      experience: 8,
    },

    {
      title: "React",
      percent: 80,
      experience: 8,
    },
    {
      title: "Node Js",
      percent: 60,
      experience: 6,
    },
  ],
};

const experienceSection = [
  {
    icon: "upwork.png",
    title: "Upwork",
    description: "Top Rated Plus Software Engineer",
    year: "April 2020 - Present",
  },
  {
    icon: "doyo.jpeg",
    title: "Do Your Order",
    description: "Software Engineer",
    year: "Jan 2021 - Present",
  },
  {
    icon: "akdn.png",
    title: "Aga Khan Development Network",
    description: "Flutter Developer",
    year: "Dec 2020 - Dec 2022",
  },
];
const bigProject = [
  {
    img: "preview/doyo_preview.webp",
    name: "Do Your Order",
    desc: "The all-in-one mobile-friendly solution for restaurants. Doyo app developed using Flutter framework for android, ios and web as well. That app has a lot of features like push notifications, deep linking, QR code scanning, Firebase, Google Maps, pdf generating, pdf scanning, 14+ different language, Image cropping and compressing, websockets, api, online payments using stripe and much more. Doyo allows restaurants to manage their orders, sales, report and much more.",
    platform: "Flutter / Dart",
    google: "https://play.google.com/store/apps/details?id=com.app.doyourorder",
    apple:
      "https://apps.apple.com/us/app/do-your-order/id1558810951?platform=iphone",
    github: "",
    websiteUrl: "https://doyourorder.com/",

    isweb: false,
    snaps: [],
  },

  {
    img: "preview/hauzy_preview.png",
    name: "Hauzy",
    desc: "Working on mobile app using flutter",
    platform: "Flutter / Dart",
    google: "",
    apple: "",
    github: "",
    isweb: false,
    snaps: [],
  },
];
const projectSection = [
  {
    img: "preview/accounty_preview.png",
    name: "ACCOUNTY GO",
    desc: "The receipt scanner in your pocket. With just a few clicks you can also see useful key figures such as sales, gross profit, etc.",
    platform: "Flutter / Dart",
    google: "https://play.google.com/store/apps/details?id=com.app.accounty",
    apple:
      "https://apps.apple.com/us/app/accounty-go/id1658777699?platform=iphone",
    github: "",
    websiteUrl: "",

    isweb: false,
    snaps: [],
  },
  {
    img: "preview/ppema preview.jpeg",
    name: "Ppema App",
    desc: "Ppema is using firebase as backend. Features that include videos playing, multilingual languages, survey taken, etc.",
    platform: "Flutter / Dart",
    google: "https://play.google.com/store/apps/details?id=com.akdndhrc.ppema",
    apple:
      "https://apps.apple.com/us/app/personal-protective-equipments/id1585633837?platform=iphone",
    github: "",
    isweb: false,
    snaps: [
      { img: "aku/ppema 1.png" },
      { img: "aku/ppema 6.png" },
      { img: "aku/ppema 2.png" },
      { img: "aku/ppema 3.png" },
      { img: "aku/ppema 4.png" },
      { img: "aku/ppema 5.png" },
    ],
  },

  {
    img: "preview/corona check preview.jpeg",
    name: "Corona Check",
    desc: "Corona Check is using firebase as backend. Features that include Corona verification Q/A, videos playing, multilingual languages, survey taken, etc.",
    platform: "Flutter / Dart",
    google:
      "https://play.google.com/store/apps/details?id=com.edu.aku.akuhccheck",
    apple:
      "https://apps.apple.com/us/app/corona-check/id1505063249?platform=iphone",
    isweb: false,
    github: "",
    snaps: [
      { img: "aku/corona 1.png" },
      { img: "aku/corona 6.png" },
      { img: "aku/corona 2.png" },
      { img: "aku/corona 3.png" },
      { img: "aku/corona 4.png" },
      { img: "aku/corona 5.png" },
    ],
  },

  {
    img: "preview/august preview.jpeg",
    name: "August Mobile App",
    desc: "August Mobile App is using firebase as backend. Features that include drivers live tracking, menu, cart, order placement, job posting, driver searching, notification,job searching, order searching etc",
    platform: "Flutter / Dart",
    google: "",
    apple: "",
    github: "",
    isweb: false,
    snaps: [
      { img: "august/A_res 1.png" },
      { img: "august/A_res 2.png" },
      { img: "august/A_res 3.png" },
      { img: "august/A_res 4.png" },
      { img: "august/A_res 5.png" },
      { img: "august/A_res 6.png" },
      { img: "august/A_res 7.png" },
    ],
  },

  {
    img: "preview/circulate_app_preview.png",
    name: "Circulate App",
    desc: "Circulate App is using firebase as backend. Features that include live tracking, rating system, shop, etc",
    platform: "Flutter Dart",
    google:
      "https://play.google.com/store/apps/details?id=com.devex.circulateapp",
    apple: "",
    isweb: false,
    github: "",
    snaps: [],
  },
  {
    img: "preview/clt_app_preview.png",
    name: "Clt App",
    desc: "Clt App is based on the rest api.",
    platform: "Flutter / Dart",
    google: "https://play.google.com/store/apps/details?id=com.cltfarm.clt",
    apple: "",
    github: "",
    isweb: false,
    snaps: [],
  },

  {
    img: "preview/parhlo_app_preview.png",
    name: "Parhlo Kitab",
    desc: "Parhlo App is using firebase as backend. Fetures that include online e-books downloads, books and author searching, Lock unlocked books, favorites feature, etc",
    platform: "Flutter / Dart",
    isweb: false,
    google:
      "https://play.google.com/store/apps/details?id=com.developer.bookapp",
    apple: "",
    github: "",
    snaps: [],
  },
  {
    img: "preview/glorify_app_preview.png",
    name: "Glorify App",
    desc: "Glorify App is an open source app in which i am using github api by which user can search github users, and their repositories.",
    platform: "Flutter / Dart",
    google: "",
    apple: "",
    isweb: false,
    github: "https://github.com/safwanidrees/GithubTimelineFlutter",
    snaps: [],
  },
  {
    img: "preview/noloom_app_preview.png",
    name: "Noloom App",
    desc: "Noloom App is using firebase as backend. Fetures that include teacher, student registration, courses available, course audio and pdf available, favorites feature, etc",
    platform: "Flutter / Dart",
    google: "",
    apple: "",
    github: "",
    isweb: false,
    snaps: [],
  },
];

const reviewSection = [
  {
    name: "Richard ",
    review:
      "Safwan does very good work and I can recommend him to anyone who wants to get high quality design done by using dart. He is also very proactive and always attend meetings on time.",
  },
  {
    name: "Pawel R",
    review:
      "Safwan did a great job as always! This time he developed both FrontEnd (ReactJS) and BackEnd (Cloud Functions with NodeJS and Google APIs).",
  },
  {
    name: "Andre ",
    review: "One of the best developers",
  },
  {
    name: "Usoof ",
    review:
      "The freelancer was very cooperative and helpful. He suggested good changes and took care of code quality.",
  },
  {
    name: "Serven ",
    review:
      'I had an excellent experience working with Safwan. He is a true expert in the mobile development field. He quickly understood how the app I envisioned should look like and laid out a clear path on how to develop the desired features. His work is always very precise and often requires no revisions at all or only minimal adjustments, which is completely common in software development. He is also very reliable. Safwan definitely works according to the saying "Your word is your bond". He supported me from A to Z. From sketches of the app to the publication in the Apple App and Google Play Store. I am glad that I found a very professional and reliable app developer with Safwan. Thank you very much for your work! I would be happy to work with you again in the future.',
  },

  {
    name: "Pawel R",
    review:
      "Safwan did an exeptional job! He created a great App for us in no time. Communication and the quality of work was excelent as well. I strongly recommend Safwan for a contract and will definitely hire him again if need his skills in the future.",
  },

  { name: "Shajeel A", review: "Amazing Dev. Highly Recommended." },
  {
    name: "Pawel R",
    review:
      "Job perfectly done, as always. Web app created very fast (as per my request) and with high quality. Good communication, all the changes made as requested. I was always up to date with the progress of work and demo sessions (showing app at different stages of development) suggested by Safwan helped a lot as well. Highly recommend!",
  },
  {
    name: "Ebede M",
    review:
      "Safwan fantastic to work with. He finished ahead of schedule and was able to take the initiative to think of things I hadn't even considered",
  },
  {
    name: "Ebede M",
    review: "hard working and engaged personne. I WILL WORK WITH AGAIN",
  },
  {
    name: "Ezaddin M",
    review: "Hard worker. always available. Definitely I will use him again",
  },
];

export {
  introSection,
  skillSection,
  experienceSection,
  projectSection,
  reviewSection,
  bigProject,
};
